module.exports = __webpack_public_path__ + "img/reentry-blue.d2f1c702.png";